
// import { useState, useEffect } from "react";

// // Custom Hook לזיהוי מובייל
// const useIsMobile = (breakpoint = 768) => {
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth <= breakpoint);
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, [breakpoint]);

//   return isMobile;
// };

// export default function QuestionEditor({ value, onChange }) {
//   const [q, setQ] = useState(value);
//   const isMobile = useIsMobile();
  
//   const set = (patch) => {
//     const next = { ...q, ...patch };
//     setQ(next);
//     onChange(next);
//   };

//   return (
//     <div className="card" dir="rtl" style={{marginBottom:'10px'}}>
//       <label>טקסט השאלה</label>
//       <textarea
//         value={q.prompt}
//         onChange={(e) => set({ prompt: e.target.value })}
//       />
//       <label>תמונה (URL)</label>
//       <input
//         value={q.imageUrl || ""}
//         onChange={(e) => set({ imageUrl: e.target.value })}
//       />
//       <h4>תשובות</h4>
//       {q.answers.map((a, i) => (
//         <div
//           key={i}
//           style={{
//             display: "flex",
//             flexDirection: isMobile ? "column" : "row",
//             gap: isMobile ? 12 : 8,
//             marginBottom: isMobile ? 20 : 10,
//             padding: isMobile ? "12px" : "0",
//             background: isMobile ? "#ecececff" : "transparent",
//             borderRadius: isMobile ? "8px" : "0",
//           }}
//         >
//           <input
//             style={{ flex: isMobile ? "none" : 1 }}
//             placeholder="תווית (למשל: הטרדה)"
//             value={a.label}
//             onChange={(e) => {
//               const answers = [...q.answers];
//               answers[i] = { ...a, label: e.target.value };
//               set({ answers });
//             }}
//           />
//           <input
//             style={{ flex: isMobile ? "none" : 1 }}
//             placeholder="הסבר"
//             value={a.explain}
//             onChange={(e) => {
//               const answers = [...q.answers];
//               answers[i] = { ...a, explain: e.target.value };
//               set({ answers });
//             }}
//           />
//           <label
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: isMobile ? "center" : "flex-start",
//               gap: 8,
//               padding: isMobile ? "10px" : "0",
//               background: a.isCorrect ? "rgba(39, 174, 96, 0.2)" : "transparent",
//               borderRadius: "8px",
//               cursor: "pointer",
//               minWidth: isMobile ? "100%" : "120px",
//             }}
//           >
//             <input
//               type="checkbox"
//               checked={a.isCorrect}
//               onChange={(e) => {
//                 const answers = [...q.answers];
//                 answers[i] = { ...a, isCorrect: e.target.checked };
//                 answers[1 - i] = {
//                   ...answers[1 - i],
//                   isCorrect: !e.target.checked,
//                 };
//                 set({ answers });
//               }}
//               style={{
//                 width: 20,
//                 height: 20,
//                 cursor: "pointer",
//               }}
//             />
//             <span style={{ 
//               fontWeight: a.isCorrect ? "bold" : "normal",
//               color: a.isCorrect ? "#27ae60" : "inherit"
//             }}>
//               נכונה
//             </span>
//           </label>
//         </div>
//       ))}
//     </div>
//   );
// }


// client/src/pages/Admin/CourseEditor/QuestionEditor.jsx
import { useState, useEffect } from "react";

const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};

export default function QuestionEditor({ value, index, onChange, onRemove }) {
  const [q, setQ] = useState(value);
  const [expanded, setExpanded] = useState(false);
  const isMobile = useIsMobile();
  
  const set = (patch) => {
    const next = { ...q, ...patch };
    setQ(next);
    onChange(next);
  };

  // עדכון כשהערך משתנה מבחוץ
  useEffect(() => {
    setQ(value);
  }, [value]);

  const isValid = q.prompt?.trim() && q.answers?.some(a => a.isCorrect);

  return (
    <div 
      className="admin-card" 
      style={{
        borderColor: isValid ? 'var(--admin-success)' : 'var(--admin-warning)',
        borderWidth: '2px',
      }}
    >
      {/* Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: expanded ? '20px' : '0',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span style={{
            width: '32px',
            height: '32px',
            borderRadius: '8px',
            background: 'var(--admin-primary)',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: '700',
            fontSize: '0.9rem',
          }}>
            {index + 1}
          </span>
          <div>
            <h4 style={{ margin: 0, color: 'var(--admin-text)', fontSize: '1rem' }}>
              {q.prompt?.slice(0, 50) || 'שאלה ללא טקסט'}
              {q.prompt?.length > 50 && '...'}
            </h4>
            <div style={{ fontSize: '0.8rem', color: 'var(--admin-text-muted)', marginTop: '4px' }}>
              {isValid ? (
                <span style={{ color: 'var(--admin-success)' }}>✓ תקין</span>
              ) : (
                <span style={{ color: 'var(--admin-warning)' }}>⚠ חסרים פרטים</span>
              )}
              {' • '}
              תשובה נכונה: {q.answers?.find(a => a.isCorrect)?.label || 'לא נבחרה'}
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '8px' }}>
          <button
            className="admin-btn secondary sm"
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? '▲ צמצם' : '▼ הרחב'}
          </button>
          <button
            className="admin-btn danger sm"
            onClick={onRemove}
          >
            🗑️
          </button>
        </div>
      </div>

      {/* Expanded Content */}
      {expanded && (
        <div style={{ marginTop: '16px' }}>
          {/* Question Text */}
          <div className="form-group">
            <label className="admin-label required">טקסט השאלה</label>
            <textarea
              className="admin-textarea"
              value={q.prompt || ''}
              onChange={(e) => set({ prompt: e.target.value })}
              placeholder="הזן את טקסט השאלה..."
              rows={3}
            />
          </div>

          {/* Image URL */}
          <div className="form-group">
            <label className="admin-label">תמונה (URL)</label>
            <input
              className="admin-input"
              value={q.imageUrl || ""}
              onChange={(e) => set({ imageUrl: e.target.value })}
              placeholder="https://..."
            />
            {q.imageUrl && (
              <img 
                src={q.imageUrl} 
                alt="תצוגה מקדימה"
                style={{ 
                  maxWidth: '200px', 
                  maxHeight: '150px',
                  borderRadius: '8px',
                  marginTop: '8px',
                  border: '1px solid var(--admin-border)'
                }}
                onError={(e) => e.target.style.display = 'none'}
              />
            )}
          </div>

          {/* Answers */}
          <div className="form-group">
            <label className="admin-label">תשובות</label>
            <div style={{ display: 'grid', gap: '12px' }}>
              {q.answers?.map((a, i) => (
                <div
                  key={i}
                  style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? '1fr' : 'auto 1fr 1fr auto',
                    gap: '12px',
                    padding: '16px',
                    background: a.isCorrect 
                      ? 'rgba(34, 197, 94, 0.1)' 
                      : 'var(--admin-bg)',
                    borderRadius: '10px',
                    border: a.isCorrect 
                      ? '2px solid var(--admin-success)' 
                      : '1px solid var(--admin-border)',
                    alignItems: 'center',
                  }}
                >
                  {/* Correct checkbox */}
                  <label style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    cursor: 'pointer',
                    padding: '8px 12px',
                    borderRadius: '8px',
                    background: a.isCorrect ? 'var(--admin-success)' : 'var(--admin-card-hover)',
                    color: a.isCorrect ? 'white' : 'var(--admin-text)',
                    fontWeight: a.isCorrect ? '600' : '400',
                    justifyContent: 'center',
                    minWidth: isMobile ? 'auto' : '100px',
                  }}>
                    <input
                      type="checkbox"
                      checked={a.isCorrect}
                      onChange={(e) => {
                        const answers = [...q.answers];
                        answers[i] = { ...a, isCorrect: e.target.checked };
                        // רק תשובה אחת יכולה להיות נכונה
                        answers[1 - i] = { ...answers[1 - i], isCorrect: !e.target.checked };
                        set({ answers });
                      }}
                      style={{ 
                        accentColor: 'var(--admin-success)',
                        width: '16px',
                        height: '16px',
                      }}
                    />
                    {a.isCorrect ? '✓ נכונה' : 'נכונה'}
                  </label>

                  {/* Answer label */}
                  <input
                    className="admin-input"
                    style={{ flex: 1 }}
                    placeholder="תווית (למשל: הטרדה)"
                    value={a.label || ''}
                    onChange={(e) => {
                      const answers = [...q.answers];
                      answers[i] = { ...a, label: e.target.value };
                      set({ answers });
                    }}
                  />

                  {/* Explanation */}
                  <input
                    className="admin-input"
                    style={{ flex: 1 }}
                    placeholder="הסבר (אופציונלי)"
                    value={a.explain || ''}
                    onChange={(e) => {
                      const answers = [...q.answers];
                      answers[i] = { ...a, explain: e.target.value };
                      set({ answers });
                    }}
                  />

                  {/* Answer indicator */}
                  <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '10px',
                    background: a.isCorrect 
                      ? 'var(--admin-success)' 
                      : 'var(--admin-card-hover)',
                    color: a.isCorrect ? 'white' : 'var(--admin-text)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '700',
                    fontSize: '1.1rem',
                  }}>
                    {a.isCorrect ? '✓' : i === 0 ? 'א' : 'ב'}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Preview */}
          {isValid && (
            <div style={{
              marginTop: '20px',
              padding: '16px',
              background: 'rgba(59, 130, 246, 0.1)',
              borderRadius: '10px',
              border: '1px solid var(--admin-primary)',
            }}>
              <h5 style={{ 
                margin: '0 0 12px 0', 
                color: 'var(--admin-primary)',
                fontSize: '0.85rem',
              }}>
                👁️ תצוגה מקדימה
              </h5>
              <div style={{ 
                color: 'var(--admin-text)', 
                fontWeight: '500',
                marginBottom: '12px'
              }}>
                {q.prompt}
              </div>
              {q.answers?.map((a, i) => (
                <div 
                  key={i}
                  style={{
                    padding: '8px 12px',
                    borderRadius: '6px',
                    marginBottom: '6px',
                    background: a.isCorrect 
                      ? 'rgba(34, 197, 94, 0.2)' 
                      : 'var(--admin-bg)',
                    border: a.isCorrect 
                      ? '1px solid var(--admin-success)' 
                      : '1px solid var(--admin-border)',
                    color: 'var(--admin-text)',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <span>{a.label}</span>
                  {a.isCorrect && (
                    <span style={{ 
                      color: 'var(--admin-success)', 
                      fontWeight: '600',
                      fontSize: '0.85rem'
                    }}>
                      ✓ תשובה נכונה
                    </span>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}